import React from 'react';
import { Link } from 'react-router-dom';
import Bookshelf from './Bookshelf';

const ListBooks = (props) => {
    const { books, onShelfChange } = props;
    
    return (
        <div className="list-books">
            <div className="list-books-title">
                <h1>MyReads</h1>
            </div>
            <div className="list-books-content">
                <div>
                    <Bookshelf 
                        title="Currently Reading" 
                        shelf="currentlyReading"
                        books={books}
                        onShelfChange={onShelfChange}
                    />
                    <Bookshelf 
                        title="Want to Read" 
                        shelf="wantToRead"
                        books={books} 
                        onShelfChange={onShelfChange}
                    />
                    <Bookshelf 
                        title="Read" 
                        shelf="read"
                        books={books} 
                        onShelfChange={onShelfChange}
                    />
                </div>
            </div>
            <div className="open-search">
                <Link to="/search">Add a book</Link>
            </div>
        </div>
    );
}

export default ListBooks;